module.exports = __webpack_public_path__ + "img/bannerx2.a2c628cc.png";